import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import {
  Edit,
  TextInput,
  ReferenceInput,
  LongTextInput,
  SelectInput,
  TabbedForm,
  FormTab,
  ReferenceManyField,
  ImageInput,
  ImageField,
  DateInput,
  Datagrid,
  DateField,
  TextField,
  BooleanField,
  required,
  REDUX_FORM_NAME,
} from 'react-admin';
import { formValueSelector } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import UploadToolbar from 'components/UploadToolbar';
import RichTextInput from 'ra-input-rich-text';
import Cover from './Cover';
import Title from './Title';
import PictureNote from 'components/PictureNote';

const styles = {
  root: {
    marginTop: '24px',
  },
};

const types = [
  { id: 'normal', name: 'Normal' },
  { id: 'special', name: 'Special' },
  { id: 'birthday', name: 'Birthday' },
];
const themes = [{ id: 'light', name: 'Light' }, { id: 'dark', name: 'Dark' }];

const customValidation = values => {
  const errors = {};
  if (values.started_at > values.expired_at) {
    errors.expired_at = ['Expired at must be greater than Started at'];
  }
  return errors;
};

class EditForm extends Component {
  state = {
    carBrandID: '',
    type: '',
  };

  static getDerivedStateFromProps(props, state) {
    if (props.carBrandID !== state.carBrandID) {
      return {
        carBrandID: props.carBrandID,
      };
    }
    return null;
  }

  handleChangeCarBrand = (e, value) => {
    this.setState({ carBrandID: value });
  };
  handleChangeType = (e, value) => {
    this.setState({ type: value });
  };

  render() {
    const { classes, carBrandID, type, dispatch, ...props } = this.props;

    return (
      <Edit title={<Title />} {...props}>
        <TabbedForm validate={customValidation} toolbar={<UploadToolbar source={['cover_url']} />}>
          <FormTab label="General">
            <ReferenceInput
              source="car_brand_id"
              reference="brands"
              validate={required()}
              onChange={this.handleChangeCarBrand}
              perPage={-1}
            >
              <SelectInput optionText="name" />
            </ReferenceInput>
            {carBrandID && (
              <ReferenceInput
                source="car_model_id"
                reference="models"
                filter={{ car_brand_id: carBrandID }}
                perPage={-1}
                emptyValue={0}
                allowEmpty={true}
              >
                <SelectInput optionText="name" />
              </ReferenceInput>
            )}
            <Cover />
            <ImageInput source="qcover_url" label="Cover" accept="image/jpeg,image/png">
              <ImageField source="src" title="title" />
            </ImageInput>
            <PictureNote width="400" height="600" />
            <SelectInput source="type" choices={types} validate={required()} onChange={this.handleChangeType} />
            {type !== 'normal' && <SelectInput source="theme" choices={themes} validate={required()} />}
            {type !== 'normal' && <TextInput source="headline" label={'Headline'} validate={required()} />}
            {type !== 'normal' && <TextInput source="subheadline" label={'Sub headline'} validate={required()} />}
            <TextInput source="title" label={'Title'} validate={required()} />
            <LongTextInput source="description" validate={required()} />
            <RichTextInput source="t_and_c" label={'T&C'} validate={required()} />
            <DateInput source="started_at" label={'Start Date'} validate={required()} />
            <DateInput source="expired_at" label={'End Date'} validate={required()} />
          </FormTab>
          <FormTab label="Redeemed Info">
            <ReferenceManyField addLabel={false} reference="user-vouchers" target="voucher_id">
              <Datagrid>
                <DateField source="created_at" label="Created At" showTime={true} />
                <DateField source="updated_at" label="Updated At" showTime={true} />
                <TextField source="user.first_name" label="First Name" />
                <TextField source="user.last_name" label="Last Name" />
                <BooleanField source="redeemed" />
              </Datagrid>
            </ReferenceManyField>
          </FormTab>
        </TabbedForm>
      </Edit>
    );
  }
}

const formSelector = formValueSelector(REDUX_FORM_NAME);
const mapStateToProps = state => {
  return {
    carBrandID: formSelector(state, 'car_brand_id'),
    type: formSelector(state, 'type'),
    currentValues: getFormValues('record-form')(state),
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(EditForm);



// WEBPACK FOOTER //
// ./src/containers/Voucher/EditForm.js